export default __webpack_public_path__ + "static/Graphik-Medium-Web-d89b8b28c5e47f370a4cce74933e04e8.woff";